export const termsAcceptanceInitialState = {
  termsAndConditions: '',
  privacyPolicy: '',
  isLoadingData: false
}

export type TermsAcceptanceState = typeof termsAcceptanceInitialState
